"use strict";
/// <reference path="../../../../Trillium.UI/TypeScript/Models/Website/TabComponentViewModel.tsx"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var TabItem_1 = __importDefault(require("../TabComponent/TabItem"));
var TabItemNav_1 = __importDefault(require("../TabComponent/TabItemNav"));
var TabItemMobile_1 = __importDefault(require("../TabComponent/TabItemMobile"));
var TabComponent = /** @class */ (function (_super) {
    __extends(TabComponent, _super);
    function TabComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleTabClick = function () { };
        return _this;
    }
    TabComponent.prototype.render = function () {
        return (react_1.default.createElement("div", { className: "container pb-40" },
            react_1.default.createElement("div", { className: "row" },
                react_1.default.createElement("div", { className: "d-none d-lg-block d-xl-block col-sm-12" },
                    react_1.default.createElement("ul", { className: "nav nav-tabs md-tabs d-flex justify-content-center", id: "TabNav_" + this.props.UniqueKey, role: "tablist" }, this.props.Items.map(function (item, i) {
                        return react_1.default.createElement(TabItemNav_1.default, { key: i, UniqueKey: item.UniqueKey, ParentUniqueKey: item.ParentUniqueKey, Title: item.Title, Index: i });
                    })),
                    react_1.default.createElement("div", { className: "tab-content card pt-3", id: "TabContent_" + this.props.UniqueKey }, this.props.Items.map(function (item, i) {
                        return react_1.default.createElement(TabItem_1.default, { key: i, UniqueKey: item.UniqueKey, ParentUniqueKey: item.ParentUniqueKey, Title: item.Title, Index: i, Content: item.Content, Note: item.Note });
                    }))),
                react_1.default.createElement("div", { className: "d-block d-sm-block d-md-block d-lg-none col-sm-12" },
                    react_1.default.createElement("div", { className: "md-tabs-accordion accordion md-accordion", id: "TabContent2_" + this.props.UniqueKey, role: "tablist", "aria-multiselectable": "true" }, this.props.Items.map(function (item, i) {
                        return react_1.default.createElement(TabItemMobile_1.default, { key: i, UniqueKey: item.UniqueKey, ParentUniqueKey: item.ParentUniqueKey, Title: item.Title, Index: i, Content: item.Content, Note: item.Note });
                    }))))));
    };
    return TabComponent;
}(react_1.default.Component));
exports.default = TabComponent;
